import axiosInstance from "./axios";

export const searchLocation = async (data) => {
    try {
      const response = await axiosInstance.post('/customer-locations/search', data);
      return response.data;
    } catch (e) {
      throw e;
    }
  };